import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import { ConfluenceIcon } from '@atlaskit/logo';

import messages from './messages';

export const FinalizeActionButton = () => {
	return (
		<Button
			iconBefore={() => <ConfluenceIcon appearance="brand" size="xxsmall" shouldUseNewLogoDesign />}
		>
			<FormattedMessage {...messages.addToSpaceButton} />
		</Button>
	);
};
